<template>
    <div>

        <div 
            class="cursor-pointer border md:mr-2 rounded-lg bg-gray-50 border-gray-200"
            :class="{ 'mt-4': loan.status === 'current' }"
        >
            <div class="flex justify-between items-center bottom-line p-4">
                <h6 class="text-base font-semibold">Pay loan in full</h6>
            </div>
            <div v-if="canRequestPayInFull">
                <div class="pay-full-info p-4">Click here to view your loan balance as of today should you wish to pay your loan in full.</div>

                <div class="p-4 pt-0">
                    <button @click="onRequestInfoClick" type="submit" class="mt-4 block w-full no-underline border border-primary-700 rounded text-primary-700 text-center text-base font-semibold py-3" data-testid="payinfull-info">
                        <template v-if="!loadingInfo">
                            Pay in full
                        </template>
                        <template v-else>
                            <i class="fa fa-circle-notch fa-spin" />
                        </template>
                    </button>
                </div>

                <div v-show="errorMessage" class="error-message text-danger text-center pb-4">
                    {{ errorMessage }}
                </div>
            </div>
            <div v-else>
                <div class="pay-full-info p-4">You have scheduled a payment of {{ amountScheduled | money }} to be drafted on {{ dateScheduled }}.</div>
            </div>
        </div>

        <AppModal :show-modal="openModal" @close="handleCloseModal" :use-min-height="false">
            <div class="conform-full-payment">
                <h6 class="mb-4 font-semibold">WARNING: you are about to schedule a payment</h6>
                <p class="text-left">Pay your loan in full by scheduling a payment of <b>{{ loanBalance | money }}</b> for the next business day <b>({{ nextBusinessDate }})</b></p>
                <div class="flex gap-2 justify-end">
                    <button
                        @click="onCancelFullPayment" 
                        type="button" 
                        data-testid="cancel-full-payment"
                        class="border border-primary-700 text-primary-700 font-medium px-4 py-3 mt-8 rounded-md hover:bg-darkred">Cancel</button>
                    <button
                        @click="onConfirmFullPayment" 
                        type="button" 
                        data-testid="confirm-full-payment"
                        class="bg-action text-white font-medium px-4 py-3 mt-8 rounded-md hover:bg-darkorange">

                        <template v-if="!loadingConfirm">
                            Confirm
                        </template>
                        <template v-else>
                            <i class="fa fa-circle-notch fa-spin" />
                        </template>
                    
                    </button>
                </div>
            </div>
        </AppModal>
    </div>

</template>

<script>

import AppModal from '../../../components/AppModal';

export default {

    name: "FullPayment",

    props: {
        loan: {
            type: Object,
            required: true
        },
    },

    components: {
        AppModal
    },

    data() {
        return {
            loanBalance: null,
            nextBusinessDate: '',
            openModal: false,
            loadingInfo: false,
            loadingConfirm: false,
            errorMessage: '',
            requested: false
        }
    },

    computed: {
        canRequestPayInFull() {
            return this.loan.status == 'current' && !this.requested;
        },

        amountScheduled() {
            if(this.loanBalance) {
                return this.loanBalance;
            }

            return this.loan.pif_amount;
        },

        dateScheduled() {
            if(this.nextBusinessDate.length > 0) {
                return this.nextBusinessDate;
            }

            return this.loan.full_payment_scheduled_at;
        }
    },

    mounted() {
        console.log(this.loan);
    },

    methods: {
        onRequestInfoClick() {
            window.LogRocket?.track?.('full_payment_requested', {
                loan_id: this.loan.id,
                loan_status: this.loan.status
            });
            this.requestInfo();
        },

        onCancelFullPayment() {
            window.LogRocket?.track?.('full_payment_cancelled', {
                loan_id: this.loan.id,
                loan_balance: this.loanBalance
            });
            this.handleCloseModal();
        },

        onConfirmFullPayment() {
            window.LogRocket?.track?.('full_payment_confirmed', {
                loan_id: this.loan.id,
                loan_balance: this.loanBalance,
                payment_date: this.nextBusinessDate
            });
            this.confirmFullPayment();
        },

        handleCloseModal() {
            this.openModal = false;
            // refresh page
            window.location.reload();
        },

        handleShowModal() {
            this.openModal = true;
        },

        requestInfo() {
            this.loadingInfo = true;
            this.errorMessage = '';

            this.$http.post(`/account/loans/${this.loan.id}/full-payment-info`)
                .then(response => {

                    this.loanBalance = response.data.loanBalance;
                    this.nextBusinessDate = response.data.nextBusinessDate;

                    // Track modal opened
                    window.LogRocket?.track?.('full_payment_modal_opened', {
                            loan_id: this.loan.id,
                            payoff_amount: this.loanBalance,
                            scheduled_date: this.nextBusinessDate
                        });


                    this.handleShowModal();
                })
                .catch(error => {
                    console.log(error.response.data);
                    this.errorMessage = error.response?.data?.error || 'An unexpected error occurred';
                })
                .finally(() => {
                    this.loadingInfo = false;
                });
        },

        confirmFullPayment() {
            this.loadingConfirm = true;
            this.errorMessage = '';

            this.$http.post(`/account/loans/${this.loan.id}/confirm-pull-payment`)
                .then(response => {
                    this.requested = true;

                    // Track successful payment scheduling
                    window.LogRocket?.track?.('full_payment_scheduled_success', {
                            loan_id: this.loan.id,
                            amount: this.loanBalance
                        });


                    this.handleCloseModal();
                })
                .catch(error => {
                    console.log(error.data);
                    this.errorMessage = error.response?.data?.error || 'An unexpected error occurred';

                    // Track payment scheduling failure
                    window.LogRocket?.track?.('full_payment_scheduled_failed', {
                            loan_id: this.loan.id,
                            error: this.errorMessage,
                            status_code: error.response?.status
                        });

                })
                .finally(() => {
                    this.loadingConfirm = false;
                });
        }
    },
}

</script>